import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function MalpracticePlagiarismPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    MALPRACTICE & PLAGIARISM POLICY
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    (INCLUDING CHEATING AND OTHER FORMS OF UNFAIR ADVANTAGE)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Information Table */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '30%' }}>Lead Responsibility</td>
                          <td style={{ padding: '20px 30px' }}>Akindele Bakarey</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '25%' }}>Approved by</td>
                          <td style={{ padding: '20px 30px' }}>Adekunle Ayeni</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Version</td>
                          <td style={{ padding: '20px 30px' }}>V14 - 2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Date of Approval</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2025</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Effective from</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Next review date</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2026</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}><strong>ALL EMPLOYEES and FREELANCE STAFF</strong></td>
                        </tr>
                        <tr>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Record of Changes:</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Statement */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    1. Policy Statement
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    In all assessed work candidates should take care to ensure the work presented is their own and fully acknowledge the work and opinions of others. It is also the responsibility of the candidates to ensure that they do not undertake any form of cheating or other form of unfair advantage.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Scope */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    2. Scope
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    This policy and procedure apply to all internal assessments, and internal and external examinations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Legislation */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    3. Legislation
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The Human Rights Act 1998 applies to the operation of this policy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Responsibilities */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    4. Responsibilities
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    All staff have a responsibility to give full and active support for the policy by ensuring:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    4.1 The policy is known, understood and implemented.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Actions to Implement and Develop Policy */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    5. Actions to Implement and Develop Policy
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px', paddingLeft: '20px' }}>
                    5.1 An allegation of cheating, plagiarism or other unfair advantage is not the same as proof of the incident.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px', paddingLeft: '20px' }}>
                    5.2 To authenticate that the work submitted by a student for assessment has been carried out by the student.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px', paddingLeft: '20px' }}>
                    5.3 The determination of whether cheating, plagiarism, or other forms of unfair advantage (referred to in this document as academic irregularities) has occurred it should be resolved before any Examination Committee (internal or external) and reported at the first Examination Committee meeting.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px', paddingLeft: '20px' }}>
                    5.4 It is for the Examination Committee to judge the seriousness of the case and to exercise discretion, accordingly, having regard to institutional precedent where appropriate.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    5.5 Definitions and Examples
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    There are different forms of "academic irregularity" all of which may be the subject of the procedures described below. However, it is not possible to state categorically that, in all cases, every perceived academic irregularity will be proved once that matter is investigated (e.g. the copying of a design or a work of art may not in all instances amount to plagiarism – see below, Section 5.7). Each case will have to be considered on its merits and based on the strength of evidence. The following sections are different types of academic irregularity.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    5.6 <em>Cheating.</em>
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Cheating includes:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.6.1 Communicating with or copying from any other candidate during an examination except insofar as the examination regulations may specifically permit this e.g. group assessments.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.6.2 Communicating during an examination with any person other than a properly authorised invigilator or another authorised member of staff.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.6.3 Introducing any written or printed materials into the examination room, unless expressly permitted by the examination or programme regulations.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.6.4 Introducing any electronically stored information into the examination room, unless expressly permitted by the examination or programme regulations.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.6.5 Gaining access to an unauthorised material relating to an examination during or before the examination.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.6.6 Obtaining a copy of an "unseen" written examination paper in advance of the date and time for its authorised release.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    5.6.7 In any other way, the provision, or assistance in the provision, of false evidence or knowledge of understanding in examinations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Plagiarism */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    5.7 <em>Plagiarism.</em>
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The deliberate and substantial unacknowledged incorporation in a candidate's work of material derived from the work (published or unpublished) of another.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px' }}>
                    Examples of plagiarism are:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.7.1 The inclusion in a candidate's work of more than a single phrase from another person's work without the use of quotation marks and acknowledgement of the sources.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.7.2 The summarising of another person's work by simply changing a few words or altering the order of presentation, without acknowledgement.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.7.3 The substantial and unauthorised use of the ideas of another person without acknowledgement of the source.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    5.7.4 Copying the work of another candidate, with or without that candidate's knowledge or agreement.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Collusion */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    5.8 <em>Collusion.</em>
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Collusion exists where a candidate:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.8.1 Submits as entirely his/her own, with intention to gain unfair advantage, work done in collaboration with another person.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.8.2 Collaborates with another candidate in the completion of work which is intended to be submitted as that other candidate's own unaided work.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    5.8.3 Knowingly permits another candidate to copy all or part of his/her own work and to submit it as that candidate's own unaided work.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Falsifying Data */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    5.9 <em>Falsifying Data.</em>
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The presentation of data in laboratory reports, projects etc. based on experimental work falsely purported to have been carried out by the candidate or obtained by unfair means.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Personation */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    5.10 <em>Personation.</em>
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    "Personation" is the legal term of what is usually referred to by the lay person as "impersonation". Personation is thus the assumption by one person of the identity of another person with intent to deceive or to gain unfair advantage. It may exist where:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.10.1 One person assumes the identity of a candidate, with the intention of gaining unfair advantage for that candidate.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    5.10.2 The candidate is knowingly and willingly impersonated by another with the intention of gaining unfair advantage for himself/herself.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Ghosting */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    5.11 <em>Ghosting.</em>
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Ghosting exists where:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    5.11.1 A student submits as their own, work which has been produced in whole or part by another person on their behalf e.g. the use of a ghost writing service.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    5.11.2 A student seeks to make financial gain or other material gain by using work, which they have written or produced, available to another student.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Dishonest Practice */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    5.12 <em>Dishonest Practice.</em>
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The use of any other form of dishonest practice not identified by the above definitions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Procedures used to deal with the above */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    6. Procedures used to deal with the above
                  </h3>
                  
                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    6.1 Initial Procedure for In Course Assessment.
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.1.1 When an academic irregularity is suspected, the member(s) of academic staff concerned should first discuss the matter informally with the student(s) concerned and the Curriculum Leader and give the student the opportunity to present his/her case.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.1.2 If the student(s) concerned admits to the academic irregularity, then the member(s) of academic staff concerned shall report the matter and the outcome to the Principal within two working days, for the Course Team to determine the action to be taken, in accordance with paragraph 6.3 below.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.1.3 In cases where the student admits misconduct, the student should be required to sign a letter to that effect. The student should also be given the opportunity to declare academic misconduct in other work that they have previously submitted.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.1.4 If this informal meeting does not resolve the matter the member(s) of staff concerned should then, within three days or as soon as reasonably practicable following the discovery or allegation, report the matter in writing to the Curriculum Leader. The report should contain full details about the circumstances surrounding the alleged irregularity including, if appropriate, photocopies of the student's work.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    6.1.5 An allegation may be made after the work has been marked and returned to the student.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Initial Procedure for Examinations */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    6.2 Initial Procedure for Examinations.
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.2.1 Where an academic irregularity is suspected in an examination, the Invigilator concerned will inform the Co-ordinating Invigilator, and in the presence of that colleague will inform the candidate of his/her suspicions and clearly annotate the candidate's script. The student will also be advised by the invigilators that a full report will be submitted following the examination.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.2.2 The Invigilators will seek to confiscate any relevant evidence (for example, any unauthorised material) and allow the candidate to continue with the examination. However, if the candidate persists with the irregularity he/she will be expelled from the room. The candidate will also be expelled from the room if he/she refuses to submit any suspected material to the Invigilators.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.2.3 Immediately following the examination, the Invigilator will submit a full report of the matter together with the Co-ordinator Invigilator using the Invigilator Report Form. This form will be returned to the Centre Manager along with the scripts and other examination stationery. The Centre Manager will then ensure that the report is immediately sent to the Principal. The Invigilator's report should be accompanied by any relevant evidence.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.2.4 If the student(s) concerned admits to the academic irregularity at the point of being challenged by the Invigilators, then the Invigilator's report will go to the Course Team, within two working days, for the Course Team to determine the action to be taken, in accordance with paragraph 6.3 below.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    6.2.5 If a student considers other student/students to be gaining unfair advantage during an examination, it is the responsibility of the student to bring this to the attention of the Invigilator. However, no action can be taken unless the infringement of rules on behalf of the student/students is subsequently verified by the Invigilator.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Action by Academic Investigating Panel */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    6.3 Action by Academic Investigating Panel
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.3.1 Where an allegation of an academic irregularity made in accordance with paragraph 6.1 or 6.2 and not resolved through the defined informal procedures, the matter will be investigated as soon as reasonably practicable following the discovery or allegation of the irregularity by an Academic Investigating Panel to be convened comprising of at least three people, of which two will be members of academic staff external to the Centre concerned and nominated by the Principal.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.3.2 The Centre Manager should notify the members of the Panel and the student(s) concerned, within three working days* of the receipt of the report, of the date, time and place of the meeting of the Panel.
                  </p>

                  <div style={{ 
                    backgroundColor: '#F5EBFA',
                    border: '2px solid #7B3F9E',
                    borderRadius: '12px',
                    padding: '20px',
                    marginBottom: '20px',
                    fontStyle: 'italic'
                  }}>
                    <p style={{ color: '#334155', fontSize: '0.95rem', lineHeight: '1.8', margin: 0 }}>
                      *Note: If an alleged irregularity comes to light during a set of examinations, and the candidate still has some examinations to sit, this timescale shall be extended to three working days after the end of that particular set of examinations.
                    </p>
                  </div>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.3.3 The student(s) should be provided by the Panel with full details of the alleged irregularity and informed of his/her right to appear before the Panel, accompanied by a friend or representative of his/her choice and provide a written statement in response to the allegation of the alleged irregularity. Failure by the student(s) to appear before the Panel or to submit a statement will not prevent the investigation proceeding.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.3.4 The Panel may call witnesses, as appropriate, to substantiate the allegations, and will not unreasonably refuse permission for the staff or student(s) concerned to call such witnesses as they deem appropriate.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px', paddingLeft: '20px' }}>
                    6.3.5 The Panel will interview the student(s), staff, and witnesses as appropriate, consider the student's written statement, and come to a decision based on the student's statement and the supporting evidence. The student will withdraw while the Panel deliberates.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.3.6 The order of proceedings is as follows:
                  </p>

                  <div style={{ paddingLeft: '40px', marginBottom: '20px' }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                      (i) Statement of the case against the student(s) and production of evidence in support of it.
                    </p>

                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                      (ii) Statement of the case for the student(s) and production of evidence in support of it.
                    </p>

                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                      (iii) Reply to the case of the student(s) provided that, except by leave of the Panel, a reply will not be allowed where the student has produced no evidence other than his/her own.
                    </p>
                  </div>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.3.7 Evidence may be received by the Panel by oral statement, written and signed statement, or statutory declaration.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    6.3.8 Each member of the Panel has equal status save that, in the event of a disagreement about the decision, the decision shall be made by a majority of those present.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Panel Decision and SMT Action */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px', paddingLeft: '20px' }}>
                    6.3.9 If the student(s) has attended, he/she will be informed of the Panel's decision at the conclusion of the meeting. The Panel will report the outcome in writing to the student within two working days of the Panel's decision. The student(s) has no right of appeal at this stage (but see below, paragraph 7).
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    6.4 Action by SMT.
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.4.1 If an Academic Investigating Panel is satisfied that there has been no academic irregularity the SMT will consider the candidate's case in the usual way and will disregard the original allegations of irregularity.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.4.2 If an Academic Investigating Panel is satisfied that there has been an academic irregularity, or if the student admits (under paragraphs 6.1 or 6.2) that an academic irregularity has taken place, the SMT will take all the factors reported and evidence submitted into account in its consideration of the candidate's case and decide on action to be taken appropriate to the gravity of the case. This includes the power to fail the candidate for all or part of the assessment in respect of which an academic irregularity has been found to have occurred, and to determine whether the candidate should be permitted to continue on the course with or without reassessment, or whether the candidate is not permitted to continue on the course.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.4.3 It is the SMT's responsibility to decide the results of a unit affected by the academic irregularity applying relevant action and, to determine whether the candidate can continue the course in the light of the overall performance, and in the light of any recommendations from the SMT.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.4.4 Members of the SMT who have been involved with the investigation of the academic irregularity are not permitted to be present during discussion of the matter by the SMT.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px', paddingLeft: '20px' }}>
                    6.4.5 Where the academic irregularity concerned is one of <em>plagiarism</em>, the SMT <em>may</em> have regard to the following <em>guidelines</em> in arriving at a decision on what action is appropriate (under paragraph 6.4.2 above):
                  </p>

                  <div className="table-responsive" style={{ marginBottom: '30px' }}>
                    <table className="table" style={{ border: '1px solid #e2e8f0' }}>
                      <thead>
                        <tr style={{ backgroundColor: '#f8fafc' }}>
                          <th style={{ padding: '15px', borderBottom: '2px solid #e2e8f0', color: '#1e293b', fontWeight: '600' }}>Degrees of Plagiarism</th>
                          <th style={{ padding: '15px', borderBottom: '2px solid #e2e8f0', color: '#1e293b', fontWeight: '600' }}>% of Assessment Copied</th>
                          <th style={{ padding: '15px', borderBottom: '2px solid #e2e8f0', color: '#1e293b', fontWeight: '600' }}>Nature of Passage</th>
                          <th style={{ padding: '15px', borderBottom: '2px solid #e2e8f0', color: '#1e293b', fontWeight: '600' }}>Effect</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '15px', color: '#334155' }}>Total derivative</td>
                          <td style={{ padding: '15px', color: '#334155' }}>&gt;70%</td>
                          <td style={{ padding: '15px', color: '#334155' }}>All arguments</td>
                          <td style={{ padding: '15px', color: '#334155' }}>Zero mark</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '15px', color: '#334155' }}>Heavily derivative</td>
                          <td style={{ padding: '15px', color: '#334155' }}>21% - 70%</td>
                          <td style={{ padding: '15px', color: '#334155' }}>Key arguments</td>
                          <td style={{ padding: '15px', color: '#334155' }}>Deduct 30%</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '15px', color: '#334155' }}>Derivative</td>
                          <td style={{ padding: '15px', color: '#334155' }}>10% - 20%</td>
                          <td style={{ padding: '15px', color: '#334155' }}>Major arguments</td>
                          <td style={{ padding: '15px', color: '#334155' }}>Deduct 20%</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px', color: '#334155' }}>Derivative Passages</td>
                          <td style={{ padding: '15px', color: '#334155' }}>&lt;10%</td>
                          <td style={{ padding: '15px', color: '#334155' }}>Minor arguments</td>
                          <td style={{ padding: '15px', color: '#334155' }}>Deduct 10%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div style={{ 
                    backgroundColor: '#F5EBFA',
                    border: '2px solid #7B3F9E',
                    borderRadius: '12px',
                    padding: '20px',
                    marginBottom: '30px'
                  }}>
                    <p style={{ color: '#334155', fontSize: '0.95rem', lineHeight: '1.8', margin: 0, fontWeight: '500' }}>
                      <strong>NB:</strong> These are only guidelines and are not mandatory; if used, they may need to be adapted, for example, to suit the marking scheme used for the assessment in question (e.g. by deducting a number of marks rather than a percentage).
                    </p>
                  </div>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.4.6 If a candidate is deemed by the SMT to have failed part of an assessment, because of a finding of an academic irregularity, then there cannot compensate the failure.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '20px' }}>
                    6.4.7 Where an alleged academic irregularity comes to light after SMT have met to consider a candidate's assessment the procedure set out above in 6.2 will be followed and reconvened SMT will meet as soon as practicable following the receipt by the Curriculum Leader of a report from the Academic Investigating Panel. If the outcome of the reconvened SMT affects the student's result, the Curriculum Leader will inform the student(s) in writing of the reasons for the varied result and of his/her right of appeal (see paragraph 7 below).
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    6.4.8 All records of academic irregularity must be recorded in the minutes of the SMT.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Students' Right of Appeal */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    7. Students' Right of Appeal
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The student has a right of appeal against the decision of the Examination Board in accordance with the appeals procedures (as set out in the College Appeals Policy for internal assessment).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Monitoring and Evaluation */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    8. Monitoring and Evaluation
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The SMT will monitor the operation of the policy by:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '20px' }}>
                    8.1 Receiving termly reports on appeals received and their outcomes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Related Policies */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    9. Related Policies
                  </h3>
                  
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px', marginBottom: '0' }}>
                    <li>Assessment Policy</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default MalpracticePlagiarismPolicy;